<template>

  <b-modal
    size="xl"
    v-model="isVisible"
    hide-footer
    @hidden="onHidden"
    title="Detalles de la Admision"
  >
    <div v-if="this.itemAdm">
      <!-- <b-row v-if="canEdit">
        <b-col class="col-12 text-right my-1">
          <b-button variant="success" @click="onRedirectEdit">
            <i class="fas fa-edit"/>
            Editar
          </b-button>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col class="col-12 text-right">
          <b-button variant="success" @click="onRedirectEdit">
            <i class="fas fa-edit"/>
            Editar
          </b-button>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col cols="4">
          <b-card cols="12">
            <b-col cols="12" class="mb-2">
              <small class="text-muted">Informacion Paciente</small>
            </b-col>

            <b-col v-if="itemAdm.nombrePac" class="itemColumn">
              <i class="fas fa-user mr-1" title="Nombre"/>
              <span id="v-name">{{ itemAdm.apellidoPac + " " + itemAdm.nombrePac }}</span>
            </b-col>

            <b-col v-if="itemAdm.identificacionPac" class="itemColumn">
              <i class="fas fa-id-card mr-1" title="Identificación"/>
              <span id="v-name">{{ itemAdm.identificacionPac }}</span>
            </b-col>

            <b-col class="itemColumn">
              <i class="fas fa-birthday-cake mr-1" title="Edad"></i>
              <span id="v-name">{{ itemAdm.edadPac }}</span>
            </b-col>

            <b-col class="itemColumn">
              <i class="fas fa-venus-mars mr-1" title="Sexo"/>
              <span id="v-name">{{ itemAdm.sexo == -1 ? '' : itemAdm.sexo == 0 ? "Masculino" : "Femenino" }}</span>
            </b-col>

            <b-col class="itemColumn">
              <i class="fa-solid fa-heart mr-1" title="Estado Civil"/>
              <span id="v-name">{{ estadoCivilText }}</span>
            </b-col>

            <b-col class="itemColumn">
              <i class="fas fa-flag mr-1" title="Nacionalidad"></i>
              <span id="v-name">{{ itemAdm.nacionalidad || '-'}}</span>
            </b-col>

            <b-col class="itemColumn">
              <i class="fas fa-graduation-cap" style="margin-right: 10px;" title="Nivel de Educación"></i>
              <span id="v-name">{{ itemAdm.nivelEducacion || '-'}}</span>
            </b-col>
            
            <b-col class="itemColumn">
              <i class="fas fa-briefcase" style="margin-right: 10px;" title="Ocupacion / Profesion"></i>
              <span id="v-name">{{ itemAdm.profesion || '-'}}</span>
            </b-col>

            <b-col cols="12" class="my-2 mt-3">
              <small class="text-muted">Residencia</small>
            </b-col>

            <b-col class="itemColumn">
              <i class="fas fa-globe-americas" style="margin-right: 10px;" title="País"></i>
              <span id="v-name">{{ itemAdm.ubicacion1 }}</span>
            </b-col>

            <b-col class="itemColumn" v-if="itemAdm.ubicacion2">
              <i class="fas fa-map-marker-alt" style="margin-right: 10px;" title="Parroquia"></i>
              <span id="v-name">{{ itemAdm.ubicacion2 }}</span>
            </b-col>

            <b-col class="itemColumn" v-if="itemAdm.ubicacion3">
              <i class="fas fa-road" style="margin-right: 10px;" title="Calle Secundaria"></i>
              <span id="v-name">{{ itemAdm.ubicacion3 }}</span>
            </b-col>
            
            <b-col class="itemColumn" v-if="itemAdm.callePrincipalPac">
              <i class="fas fa-road" style="margin-right: 10px;" title="Calle Principal"></i>
              <span id="v-name">{{ itemAdm.callePrincipalPac }}</span>
            </b-col>

            <b-col class="itemColumn" v-if="itemAdm.calleSecundariaPac">
              <i class="fas fa-road" style="margin-right: 10px;" title="Calle Secundaria"></i>
              <span id="v-name">{{ itemAdm.calleSecundariaPac }}</span>
            </b-col>

            <b-col class="itemColumn" v-if="itemAdm.referenciaSectorPac">
              <i class="fas fa-street-view" style="margin-right: 10px;" title="Parroquia"></i>
              <span id="v-name">{{ itemAdm.referenciaSectorPac }}</span>
            </b-col>

          </b-card>

          
        </b-col>

        <b-col cols="8">

          <b-row>
            <b-card class="col-6">
              <div  class="mb-1">
                <small class="text-muted">Información Contacto</small>
              </div>

              <div v-if="itemAdm.telefonos" class="itemColumn">
                <i class="fas fa-phone mr-1" title="Celular"/>
                <span id="v-name">{{ itemAdm.telefonos }}</span>
                    
              </div>

              <div v-if="itemAdm.email" class="itemColumn">
                <i class="fas fa-envelope mr-1" title="Email"></i>
                <span id="v-name">{{ itemAdm.email }}</span>
              </div>
            </b-card>

            <b-card class="col-6">
              <div class=" mb-1">
                <small class="text-muted">Información Medica</small>
              </div>

              <div class="itemColumn">
                <span>Seguro: </span>
                <span id="v-name">{{ itemAdm.seguroActual }}</span>
              </div>

              <div class="itemColumn">
                <span>Tipo Cobertura: </span>
                <span id="v-name">{{ itemAdm.tipoCobertura || '-' }}</span>
              </div>

              <div class="itemColumn">
                <span>Num. Historia Clinica: </span>
                <span id="v-name">{{ nHistoriaClinicaLocal }}</span>      
              </div>

            </b-card>
          </b-row>

          <b-row>
            <b-card class="col-12">
              <small class="text-muted">Documentos</small>

              <hr>
              
              <LoadFileInput
                label="Cedula"
                :urlFile="itemAdm.urlCedula"
                onlyView
              />

              <hr>

              <LoadFileInput
                label="Carnet ISSFA"
                :urlFile="itemAdm.urlCarnetIssfa"
                onlyView
              />

              <hr>

              <LoadFileInput
                label="Carnet ISSPOL"
                :urlFile="itemAdm.urlCarnetIsspol"
                onlyView
              />

              <hr>

              <LoadFileInput
                label="Carnet Discapacidad"
                :urlFile="itemAdm.urlCarnetDiscapacidad"
                onlyView
              />
            </b-card>
          </b-row>
          
        </b-col>


      </b-row>

    </div>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />
  </b-modal>
  
</template>
<script>
import { required } from '@validations';
import { comprobarPermisos, calculateAgeWithDateString, capitalizeText, getEstablecimientoLS } from "@/shared/helpers";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import axios from 'axios';
import { ModalViewFile, LoadFileInput } from '@/shared/components';
import { infoPersonasService, pacientesService, segurosService } from '../services';
import { dataPersonas } from '../constants/dataPersonas';


export default {

  name: 'VerAdmision',

  props:{
    canEdit: {
      type: Boolean,
      default: true
    }
  },


  components: {
    ModalViewFile,
    LoadFileInput
  },
    
  data() {
    return {

      isVisible: false,
      fileToView: null,
      isModalFileVisible: false,


      fieldsTitulares: [
        { key: 'cedula',       label: 'Cedula',        thClass: 'text-center' },
        { key: 'nombres',      label: 'Nombres',       thClass: 'text-center' },
        { key: 'daCobertura',  label: 'Da Cobertura',  thClass: 'text-center' },
        { key: 'padreSoltero', label: 'Madre Soltera', thClass: 'text-center' },
        { key: 'acciones',     label: 'acciones',      thClass: 'text-center', sortable: true,  },
      ],

      //
      urlactual : null,
      visibleC: false,
      visibleT: true,
      collapseContactoID: '',
      collapseTitularID: '',
      openOnHover: this.$parent.hover,
      required,
      
      itemAdm: null,

      contacto:'',
      titular:'',

      optsTipoCobertura: [],
    }
  },


  created() {
    this.setTokenPaciente();
    this.setToken();
    this.onLoadDataInit();
    comprobarPermisos(this.$route);
    this.beforeStepChange();
  },

  methods: {

    async onLoadDataInit() {
      this.optsTipoCobertura = await segurosService.getTiposCoberturaSelect();
    },

    onRedirectEdit() {

      this.$router.push({
        name: 'editar_admision',
        params: { tokenPaciente: this.tokenPaciente }
      });

    },

    async descargarCedula(urlCedula) {
      this.fileToView = urlCedula;
      this.isModalFileVisible = true;
    },  
  

    async mapPaciente(item) {
      
      const { persona } = item;
      const { residencia } = persona;

      const tipoIdentificacion = persona.tipoIdentificacion === 0 
        ? 'RUC' 
        : persona.tipoIdentificacion === 1 
          ? 'Cedula' 
          : 'Passporte';

      const edad = calculateAgeWithDateString(persona.fechaNacimiento);
      const dataEdad = `${persona.fechaNacimiento} ( ${edad} años )`;

      const dataUbicacion = infoPersonasService.getUbicacionByParroquia(residencia.parroquia);

      const provincia = dataUbicacion
        ? dataUbicacion.provincia.text
        : residencia.canton?.idprovincia?.descripcion;

      const canton = dataUbicacion
        ? dataUbicacion.canton.text
        : residencia.canton?.descripcion;

      const parroquia = dataUbicacion
        ? dataUbicacion.parroquia.text
        : residencia.parroquia;


      const ubicacion1 = `${residencia.pais?.descripcion}, ${provincia}, ${canton}`;

      const barrio    = capitalizeText(residencia.barrio);

      const ubicacion2 = (parroquia || barrio)
        ? `${parroquia}, ${barrio}`
        : null;

      const callePrincipal = capitalizeText(residencia.callePrincipal);
      const calleSecundaria = capitalizeText(residencia.calleSecundaria);

      const ubicacion3 = (callePrincipal && calleSecundaria)
        ? `${callePrincipal}, ${calleSecundaria}`
        : (callePrincipal) ? residencia.callePrincipal : null;

      this.itemAdm = {
        tipoIdentificacionPac : tipoIdentificacion,
        identificacionPac     : persona.identificacion,
        nombrePac             : persona.primerNombre || "Nulo",
        apellidoPac           : persona.primerApellido,
        edadPac               : dataEdad,
        estadoCivil           : persona.estadoCivil,
        telefonos             : persona.telefono,
        sexo                  : persona.sexo,
        email                 : persona.correo,
        nacionalidad          : persona.nacionalidad?.descripcion      || '',
        nivelEducacion        : persona.nivelEducacion?.descripcion    || '',
        profesion             : persona.ocupacion?.descripcion         || '',
        nacionalidadEtnia     : persona.nacionalidadEtnia?.descripcion || '',
        pueblokichwa          : persona.pueblokichwa?.descripcion      || '',

        ubicacion1            : ubicacion1 || 'Sin informacion',
        ubicacion2            : ubicacion2 || 'Sin informacion',
        ubicacion3            : ubicacion3 || 'Sin informacion',
        
        referenciaSectorPac   : residencia.referenciaSector || '',
        
        historiaClinica   : JSON.parse(item.numHistoriaClinica),
        seguroActual      : item.segsalud?.codigo
          ? `${item.segsalud.codigo} - ${item.segsalud.descripcion}`
          : item.seguroprivado?.descripcion || 'SIN SEGURO',
        tipoCobertura     : item.tipoCobertura || '-',
       
        urlCedula             : item.persona.urlIdentificacion,
        urlCarnetDiscapacidad : item.persona.urlCarnet,
        urlCarnetIssfa        : item.persona.urlCarnetIssfa,
        urlCarnetIsspol       : item.persona.urlCarnetIsspol,

        parentesco         : item.contactoPaciente?.parentesco.descripcion,
        identificacionCont : item.contactoPaciente?.persona.identificacion,
        nombreCont         : item.contactoPaciente?.persona.primerNombre,
        apellidoCont       : item.contactoPaciente?.persona.primerApellido,
        emailCont          : item.contactoPaciente?.persona.correo,
                
        direccionCont: item.contactoPaciente?.persona.residencia.callePrincipal,
        idPaciente   : item.id,
        tokenPaciente: item.token,
        idPerPac     : item.persona.id,
        idPerCont    : item.contactoPaciente?.persona.id,
        idContacto   : item.contactoPaciente?.id,
      }


    },



    

    updatevisibleC(val = true) {
      this.visibleC = val
      this.$emit('visible', val)
    },

    updatevisiblet(val = true) {
      this.visibleT = val
      this.$emit('visible', val)
    },

    collapseOpen() {
      if (this.openOnHover) 
        this.updatevisibleC(true)
    },

    collapseClose() {
      if (this.openOnHover) 
        this.updatevisibleC(false)
    },

    calculateAge(birthdate) {
      if (birthdate) {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      } else { return 0; }

    },
    async formSubmittedAdmision() {
      this.$router.push({ name: 'consultar_admision' })
    },

    beforeStepChange(newStep, oldStep, prevent) {
      if (newStep > oldStep && !this.validateCurrentStep()) {
        prevent();
      }
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    //
    onHidden() {
      this.isVisible = false;
      this.tokenPaciente = null;
      this.$router.push({ path: this.$route.path, query: {} })
    },

    async setTokenPaciente() {

      this.tokenPaciente = this.$route.query.view_admision;
      
      if(!this.tokenPaciente) return;

      const responsePaciente = await pacientesService.getAll({ tokenPaciente: this.tokenPaciente });

      if(!responsePaciente){
        this.tokenPaciente = null;
        this.$swal('Error', 'La admision no existe', 'error');
        this.onHidden();
        return;
      }

      await this.mapPaciente(responsePaciente.pacientes[0]);

      this.isVisible = true;
    }

  },


  computed: {
    estadoCivilText() {
      const estadoCivil = dataPersonas.optsEstadoCivil.find(o => o.value === this.itemAdm.estadoCivil);
      return estadoCivil ? estadoCivil.text : '';
    },

    nHistoriaClinicaLocal() {
      const establecimiento = getEstablecimientoLS();
      return this.itemAdm.historiaClinica[establecimiento.id];
    }
  },

  watch: {
    '$route.query.view_admision': {
      handler(newValue){
        if(!newValue) return;

        this.setTokenPaciente();
      }
    },

  }
}
</script>


<style>
  .my-icon-link {
    margin-right: 10px;
    padding-left: 500px;
  }

  .itemColumn{
    margin-bottom: 5px;
  }

</style>
